

const secondsToHMSformat = (value, format) => {
  const sec = parseInt(value, 10); // convert value to number if it's string

  let hh   = Math.floor(sec / 3600); // get hours
  let mm = Math.floor((sec - (hh * 3600)) / 60); // get minutes
  let ss = sec - (hh * 3600) - (mm * 60); //  get seconds
  let hours = hh;
  let minutes = mm;
  let seconds = ss;
  //different return format
  if (!format){
    if (mm < 10) {minutes = "0"+mm;}
    if (ss < 10) {seconds = "0"+ss;}
    return hours+':'+minutes+':'+seconds; // Return is H : MM : SS
  } else if (format === 'plaintext') {
    let part1 = '';
    let part2= '';
    let part3= '';
    let part4= '';
    let part5= '';
    if (hh > 1) {part1 = hh + ' hours'}
    if (hh === 1) {part1 = hh + ' hour'}
    if (hh > 0 && minutes > 0){part2 = ' and '}
    if (mm > 1) {part3 = mm + ' mins '} else if (mm > 0) {part3 = mm + ' min'}
    if (hh<1 && mm > 1) {part4 = 'and '}
    if (hh<1) {part5 =  ss + ' seconds'}
    return part1+ part2 + part3 + part4 + part5;
  }

};

export default secondsToHMSformat;